import { Dispatch, FC, SetStateAction } from 'react';
import ErrorMesssage from 'common/components/ErrorMesssage';
import Button from 'v3/common/components/Button';
import { PhoneNumberState } from '.';

type PhoneNumberFormProps = {
  phoneNumberState: PhoneNumberState;
  onPhoneNumberSubmit: () => void;
  setPhoneNumberState: Dispatch<SetStateAction<PhoneNumberState>>;
  isLoading?: boolean;
};

const PhoneNumberForm: FC<PhoneNumberFormProps> = ({
  phoneNumberState,
  setPhoneNumberState,
  onPhoneNumberSubmit,
}) => {
  const { phoneNumber, isLoading, error } = phoneNumberState;

  return (
    <div className="phone-number-form-container">
      <div className="text-center">
        <img alt="smartphone" src="/smartphone-dial.svg" />
        <h4 className="font-weight-bold mb-1">Enter Your Phone Number</h4>
        <h5 className="text-muted">we will send you the 6 digit verification code</h5>
      </div>
      <form className="login-form text-center mt-5" id="phoneNumberForm" onSubmit={onPhoneNumberSubmit}>
        <div className="input-wrapper">
          <i className="fa-light fa-mobile input-icon" />
          <input
            key="phoneNumber"
            type="number"
            maxLength={10}
            value={phoneNumber}
            className="form-control form-control-lg"
            name="phoneNumber"
            autoFocus
            autoComplete="off"
            onChange={(event) =>
              setPhoneNumberState((prev) => ({
                ...prev,
                phoneNumber: event.target.value,
                error: null,
              }))
            }
            placeholder="E.g. 99999-99999"
          />
        </div>

        <ErrorMesssage error={{ message: error }} />

        <Button
          type="submit"
          isLoading={isLoading}
          form="phoneNumberForm"
          iconRight="fa-solid fa-arrow-turn-down-right  mt-1"
        >
          Generate otp
        </Button>
      </form>
    </div>
  );
};

export default PhoneNumberForm;
